module.exports = __webpack_public_path__ + "static/media/retirement.27949c5e.png";